import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import chat from "../../../public/images/chat.svg";
import support from "../../../public/images/support.svg";
import Cards from "../../components/Cards/Cards";
import FormWrapper from "../../helpers/FormVoip/FormWrapper";
import { useTawkWidget } from "../../helpers/useTawkWidget";
import Desktop from "./../../../public/images/Desktop";
import IconUser from "./../../../public/images/IconUser";
import Telegram from "./../../../public/images/Telegram";
import "./home.scss";

export default function Home() {
  const chatBtnRef = useRef(null);
  const supportRef = useRef(null);

  const { toggleTawk } = useTawkWidget({
    chatBtnRef,
    debug: true,
  });

  const [supportOpen, setSupportOpen] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (!supportOpen) return;

    const handleOutside = (e) => {
      if (!supportRef.current) return;
      if (!supportRef.current.contains(e.target)) {
        setSupportOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutside);
    return () => document.removeEventListener("pointerdown", handleOutside);
  }, [supportOpen]);

  const supportItems = [
    {
      key: "tg",
      type: "link",
      href: "https://t.me/VoiceXSupportBot",
      icon: <Telegram />,
      label: "Telegram",
      onPointerDown: (e) => {
        e.stopPropagation();
      },
      onClick: (e) => {
        e.stopPropagation();
        setSupportOpen(false);
      },
    },
    {
      key: "user",
      type: "btn",
      onPointerDown: (e) => {
        stop(e);
        setOpenForm(true);
        setSupportOpen(false);
      },
      icon: <IconUser />,
      label: "User",
    },
    {
      key: "desk",
      type: "btn",
      onPointerDown: (e) => {
        stop(e);
        setSupportOpen(false);
      },
      icon: <Desktop />,
      label: "Desktop",
    },
  ];

  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.05,
      },
    },
    exit: {
      transition: {
        staggerChildren: 0.08,
        staggerDirection: -1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10, scale: 0.9 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.22, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      y: 10,
      scale: 0.92,
      transition: { duration: 0.16, ease: "easeIn" },
    },
  };

  return (
    <div className="home">
      <div className="home__text">
        <h1>
          <span>VOIP & WEB</span> Solutions for you business
        </h1>
        <p>
          The digital product design & development company and your guide on the
          digital transformation journey.
        </p>
      </div>

      <Cards />

      <div className="home__buttons">
        <div className="home__buttons__chat" ref={chatBtnRef}>
          <button onClick={toggleTawk} type="button">
            <img src={chat} alt="Chat" />
          </button>
        </div>

        <div className="home__buttons__fallingDies">
          <NavLink
            className="home__buttons__fallingDies__die"
            style={{ "--i": 0 }}
            to="/warranties"
          >
            Warranties
          </NavLink>
          <NavLink
            className="home__buttons__fallingDies__die"
            style={{ "--i": 1 }}
            to="/sla"
          >
            SLA
          </NavLink>
          <NavLink
            className="home__buttons__fallingDies__die"
            style={{ "--i": 2 }}
            to="/contacts"
          >
            Contacts
          </NavLink>
          <NavLink
            className="home__buttons__fallingDies__die"
            style={{ "--i": 3 }}
            to="/termsConditions"
          >
            Terms&Conditions
          </NavLink>
          <NavLink
            className="home__buttons__fallingDies__die"
            style={{ "--i": 4 }}
            to="/agreements"
          >
            Agreements
          </NavLink>
        </div>

        <div className="home__buttons__support" ref={supportRef}>
          <button
            className="home__buttons__support__main"
            onClick={(e) => {
              e.stopPropagation();
              setSupportOpen((v) => !v);
            }}
            aria-expanded={supportOpen}
            aria-label="Support menu"
            type="button"
          >
            <img src={support} alt="Support" />
          </button>

          <AnimatePresence>
            {supportOpen && (
              <motion.div
                className="home__buttons__support__items"
                variants={containerVariants}
                initial="hidden"
                animate="show"
                exit="exit"
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                {supportItems.map((it) => (
                  <motion.div
                    key={it.key}
                    className={`home__buttons__support__items__pos home__buttons__support__items__pos--${it.key}`}
                    variants={itemVariants}
                  >
                    {it.type === "link" ? (
                      <a
                        className="home__buttons__support__items__pos__item"
                        href={it.href}
                        aria-label={it.label}
                        target="_blank"
                        rel="noopener noreferrer"
                        onPointerDown={(e) => it.onPointerDown?.(e)}
                        onClick={(e) => it.onClick?.(e)}
                      >
                        {it.icon}
                      </a>
                    ) : (
                      <button
                        className="home__buttons__support__items__pos__item"
                        type="button"
                        onPointerDown={(e) => it.onPointerDown?.(e)}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        aria-label={it.label}
                      >
                        {it.icon}
                      </button>
                    )}
                  </motion.div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {openForm && <FormWrapper onClose={() => setOpenForm(false)} />}
    </div>
  );
}
